<template>
    <q-card flat>
        <q-card-section>
            <div class="text-h5 text-bold text-uppercase">Coastal</div>
        </q-card-section>
        <q-card-section class="q-pt-none q-pl-sm" v-if="processedData[version] && processedData[version]['coastalOffshore'] && processedData[version]['coastalOffshore']['coastal']">
          <q-list bordered class="rounded-borders bottom-border" role="list">
            <q-expansion-item v-model="coastalSummary" group="coastal" header-class="bg-grey-5"  expand-separator dense @click="goTo('summary', 'COASTAL_SUMMARY')" class="exp-panel" role="listitem">
                <template v-slot:header>
                    <q-item-section class="text-uppercase text-bold">
                            Coastal Summary
                    </q-item-section>
                    <q-item-section v-if="coastalSummary">
                        <div class="row justify-end">
                            <div class="q-mt-xs q-mb-xs q-pl-sm q-pr-sm shadow-1 rounded"  @click.stop="print('coastalSummaryPane', version, 'Coastal Summary')" v-if="!printing" aria-label="Print summary"><q-icon name="print" size="xs"></q-icon></div>
                            <q-spinner v-else />
                        </div>
                    </q-item-section>
                </template>
                <router-view v-if="coastalSummary" :data="rawData" :version="version"></router-view>                   
            </q-expansion-item>
            <q-expansion-item v-model="habitats" group="coastal"  header-class="bg-grey-3" expand-separator dense  @click="goTo('habitats', 'COASTAL')" class="exp-panel" role="listitem">
                <template v-slot:header>
                    <q-item-section class="text-uppercase text-bold">
                            Habitat Characteristics
                    </q-item-section>
                </template>
                <router-view v-if="habitats" :data="rawData" :version="version"></router-view>
            </q-expansion-item>

            <q-expansion-item v-model="threats" group="coastal"  header-class="bg-grey-3"  expand-separator dense  @click="goTo('threats', 'COASTAL_THREATS')" class="exp-panel" role="listitem">
                <template v-slot:header>
                    <q-item-section class="text-uppercase text-bold">
                           Coastal Threats
                    </q-item-section>
                </template>
                <router-view v-if="threats" :data="rawData" :version="version"></router-view>
            </q-expansion-item>

            <q-expansion-item v-model="coastalOpps" group="coastal"  header-class="bg-grey-3" expand-separator dense @click="goTo('opps', 'COASTAL_PRIORITIES')" class="exp-panel" role="listitem">
                <template v-slot:header>
                    <q-item-section class="text-uppercase text-bold">
                            Coastal Opportunities/Priorities
                    </q-item-section>
                </template>
                <router-view v-if="coastalOpps" :data="rawData" :version="version"></router-view>
            </q-expansion-item>
            <q-expansion-item v-model="coastalRestoration" group="coastal" header-class="bg-grey-3" expand-separator dense @click="goTo('restoration', 'RESTORATION_PROJECTS')" class="exp-panel" role="listitem">
                <template v-slot:header>
                    <q-item-section class="text-uppercase text-bold">
                            Coastal Projects
                    </q-item-section>
                </template>
                <router-view v-if="coastalRestoration" :data="rawData" :version="version"></router-view>
            </q-expansion-item>
            <q-expansion-item
                    group="coastal"
                    dense
                    class="exp-panel"
                    expand-separator
                    label="Data Considerations"
                    @click="goTo('data', 'COASTAL_QUALITY')"
                    v-model="dataqual"
                    header-class="bg-grey-5" 
                    role="listitem"
                >
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                                Data Considerations
                        </q-item-section>
                        <!-- <q-item-section v-if="dataqual">
                            <div class="row justify-end">
                                <q-btn class="q-mt-xs" icon="print"size="sm" @click.stop="print('dataqualPane', version, 'Data Considerations')" v-if="!printing"/>
                                <q-spinner v-else />
                            </div>
                        </q-item-section> -->
                    </template>
                    <router-view v-if="dataqual" :data="rawData" :version="version"></router-view>
                </q-expansion-item>
          </q-list>
        </q-card-section>
        <q-card-section v-else>
            <div class="text-center text-h5">The AOI does not include any coastal areas.</div>
        </q-card-section>
    </q-card>
</template>
<script setup>
// @ts-nocheck
import { toRefs, ref, onMounted, watch } from "vue";
import { useRouter, useRoute } from 'vue-router';
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
const router = useRouter();
const route = useRoute();

const {  loadDataByID, ecos, print, printing, processedData } = useMapItems()
const { logGAevent } = useHelpers();

const props = defineProps({
    rawData: { type: Object },
    version: { type: Number },

})
const { rawData, version  } = toRefs(props)

const coastalSummary = ref(false)
const habitats= ref(false)
const coastalOpps = ref(false)
const ecoregion1 = ref(false)
const ecoregion2 = ref(false)
const dataqual = ref(false)
const coastalRestoration = ref(false)
const threats = ref(false)

const panelRefs = {
    coastalSummary,
    habitats,
    coastalOpps,
    coastalRestoration,
    threats,
    dataqual,
    ecoregion1,
    ecoregion2
}
const setExpansionPanel = (refName, value) =>{
  if (panelRefs[refName]) {
    panelRefs[refName].value = value;
  }
}



const goTo = (pane, layerID=null) =>{
  logGAevent("coastal_pane", pane, "")
  if (layerID){
    loadDataByID(layerID, version)
  }
  router.push({
    path: `/results${version.value}/coastal/${pane}`
  })
}

const setPanels = (path) =>{
    // console.log(path)
    if (path.includes('coastal/summary')){
        setExpansionPanel('coastalSummary', true)
    }
    if (path.includes('coastal/habitats')){
        setExpansionPanel('habitats', true)
    }

    if (path.includes('coastal/opps')){
        setExpansionPanel('coastalOpps', true)
    }
    if (path.includes('coastal/restoration')){
        setExpansionPanel('coastalRestoration', true)
    }
    if (path.includes('coastal/threats')){
        setExpansionPanel('threats', true)
    }
    if (path.includes('coastal/data')){
        setExpansionPanel('dataqual', true)
    }
    if (path.includes('coastal/ecoregion1')){
        setExpansionPanel('ecoregion1', true)
    }
    if (path.includes('coastal/ecoregion2')){
        setExpansionPanel('ecoregion2', true)
    }
}

watch(route, (nv, ov) =>{
    setPanels(nv.fullPath)
})

onMounted(() => {
    // if coming from a route (entered via URL).  expand the correct panel
    setPanels(route.path)
})

const ecoregionLabel = (ecoregion) => {
    let text = "Ecoregion Summary: " + ecos[ecoregion]
    return text
}
const infoDialogs = ref({
    wetlands: {
        pName: "Coastal Marshes",
        model: false,
        text: "More info about the importance of coastal marshes."
    },
    wetlandVuln: {
        pName: "Coastal Marsh Vulnerability",
        model: false,
        text: "More info about the vulnerability of coastal marshes."
    },
})

watch(route, (nv, ov) =>{
    setPanels(nv.fullPath)
})
onMounted(() => {
    // if coming from a route (entered via URL).  expand the correct panel
    setPanels(route.path)
})
</script>
<style scoped>
.exp-panel{
    border-top: 1px solid #aeaeae;
    border-left: 1px solid #aeaeae;
    border-right:1px solid #aeaeae;
    background-color: #ffffff;
 }
 .bottom-border{
    border-bottom:1px solid #aeaeae !important;
 }
 .result-pane-header-row{
  border-top: 1px solid white;
}
.pointer{
  cursor: pointer;
}
.rounded{
    border-radius: 3px;
}
</style>